import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {createRequestOption, createRequestBody} from '../../shared/util';
import {environment} from '../../../environments/environment';
import { map } from 'rxjs/operators';

type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;
@Injectable({ providedIn: 'root' })
export class MasterDataService {
  public resourceUrl = environment.SERVER_API_URL;

  constructor(protected http: HttpClient) {}

  queryBenefitType(req){
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'api/benefit-type/list', {  params: options});
  }
  createBenefit(body: any): Observable<EntityResponseType> {
    return this.http.post<any>(this.resourceUrl + 'api/benefit-type/', body, { observe: 'response' });
  }

  updateBenefit(body: any): Observable<EntityResponseType> {
    return this.http.put<any>(this.resourceUrl + 'api/benefit-type/' + body.id, body, { observe: 'response' });
  }

  queryBenefitDetailType(req){
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'api/benefit-detail-type/list', {  params: options});
  }
  createBenefitDetail(body: any): Observable<EntityResponseType> {
    return this.http.post<any>(this.resourceUrl + 'api/benefit-detail-type/', body, { observe: 'response' });
  }

  updateBenefitDetail(body: any): Observable<EntityResponseType> {
    return this.http.put<any>(this.resourceUrl + 'api/benefit-detail-type/' + body.id, body, { observe: 'response' });
  }
}